import { cryptoReportSegments } from '@/entities/crypto-report/api/paths';

export const cryptoReportRoutePaths = {
  list: {
    path: 'crypto-report',
    fullPath: '/crypto-report',
  },
  detail: {
    path: `crypto-report/${cryptoReportSegments.reportId}`,
    fullPath: `/crypto-report/${cryptoReportSegments.reportId}`,
  },
};
